module.exports = __webpack_public_path__ + "img/main.91631b22.png";